<template>
  <review-button-1 v-if="score === 1" />
  <review-button-2 v-else-if="score === 2" />
  <review-button-3 v-else-if="score === 3" />
  <review-button-4 v-else-if="score === 4" />
  <review-button-5 v-else-if="score === 5" />
</template>

<script>
import ReviewButton1 from "@/assets/icons/review/ReviewButton-1.vue";
import ReviewButton2 from "@/assets/icons/review/ReviewButton-2.vue";
import ReviewButton3 from "@/assets/icons/review/ReviewButton-3.vue";
import ReviewButton4 from "@/assets/icons/review/ReviewButton-4.vue";
import ReviewButton5 from "@/assets/icons/review/ReviewButton-5.vue";

export default {
  name: "ReviewScoreIcon",
  components: {
    ReviewButton1,
    ReviewButton2,
    ReviewButton3,
    ReviewButton4,
    ReviewButton5
  },
  props: {
    score: {
      type: [String, Number],
      required: true
    }
  }
};
</script>

<style scoped>
svg {
  stroke: none !important;
  image-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
